import RoutePage from "~/components/free-consult/FreeConsultPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/free-consult")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/free-consult"),
  component: RoutePage,
});
